import { ToastContainer } from "react-toastify";
import React, { useEffect } from "react";
import type { AppProps } from "next/app";
import { setUpTrpc } from "@/utils/trpc";
import "@/styles/fonts.css";
import "@/styles/globals.css";
import "react-toastify/dist/ReactToastify.css";
import { EVENTS, trackEvent } from "@/services/analytics";

const trpc = setUpTrpc();

const App: React.FC<AppProps> = ({ Component, pageProps }) => {
  useEffect(() => {
    trackEvent(EVENTS.SESSION_STARTED);
  }, []);

  return (
    <>
      <Component {...pageProps} />
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar={true}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        theme={"dark"}
      />
    </>
  );
};

export default trpc.withTRPC(App);
